<template>
  <div>
    <b-container v-for="outcome in Outcomes" :key="outcome.id">
        <b-row class="mb-5">
          <b-col cols="12" md="2">

            <a :href="outcome.appStoreAddress">
              <img class="rounded" :src="outcome.appIcon" width="100%" alt />
            </a>

            <h5>{{ outcome.appTitle }}</h5>

            <p>
            <router-link
              :to="{
                name: 'reportShow',
                params: { title: outcome.reportTitle, target: '_blank' }
              }"
              >{{ outcome.reportTitle }}</router-link>
            </p>

          </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Outcomes: [
        {
          id: 1,
          reportTitle: "2021 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
          appIcon: require("@/assets/images/appStoreImage/2021_dgu_winter/Bareun.png"),
          appTitle: "바른",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EB%B0%94%EB%A5%B8/id1552030717"
        },
        {
          id: 2,
          reportTitle: "2021 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
          appIcon: require("@/assets/images/appStoreImage/2021_dgu_winter/nulschedule.png"),
          appTitle: "널스케줄",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EB%84%90%EC%8A%A4%EC%BC%80%EC%A4%84/id1552664387"
        },
        {
          id: 3,
          reportTitle: "2021 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
          appIcon: require("@/assets/images/appStoreImage/2021_dgu_winter/stocker.png"),
          appTitle: "STOCKER",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EB%98%91%EB%98%91%ED%95%9C-ai-%ED%8E%80%EB%93%9C%EB%A7%A4%EB%8B%88%EC%A0%80-stocker/id1550061852"

        },
        {
          id: 4,
          reportTitle: "2021 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
          appIcon: require("@/assets/images/appStoreImage/2021_dgu_winter/UniCalendar.png"),
          appTitle: "유니캘린더",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EC%9C%A0%EB%8B%88%EC%BA%98%EB%A6%B0%EB%8D%94/id1555101858"
        },
        {
          id: 5,
          reportTitle: "2021 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
          appIcon: require("@/assets/images/appStoreImage/2021_dgu_winter/petdiary.png"),
          appTitle: "팻디",
          appStoreAddress:
            "https://apps.apple.com/us/app/%ED%8E%AB%EB%94%94/id1551631046"
        },
        {
          id: 6,
          reportTitle: "2020 드림인 iOS 아카데미",
          appIcon: require("@/assets/images/appStoreImage/2020_dreamin/waha.png"),
          appTitle: "Wa-ha",
          appStoreAddress:
            "https://apps.apple.com/us/app/wa-ha/id1542286897"
        },
        {
          id: 7,
          reportTitle: "2020 드림인 iOS 아카데미",
          appIcon: require("@/assets/images/appStoreImage/2020_dreamin/vridge.png"),
          appTitle: "Vridge",
          appStoreAddress:
            "https://apps.apple.com/us/app/vridge/id1541849378"

        },
        {
          id: 8,
          reportTitle: "2020 드림인 iOS 아카데미",
          appIcon: require("@/assets/images/appStoreImage/2020_dreamin/mogrige.png"),
          appTitle: "모그리지",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EB%AA%A8%EA%B7%B8%EB%A6%AC%EC%A7%80/id1541566943"

        },
        {
          id: 9,
          reportTitle: "2020 드림인 iOS 아카데미",
          appIcon: require("@/assets/images/appStoreImage/2020_dreamin/gak.png"),
          appTitle: "GAK",
          appStoreAddress:
            "https://apps.apple.com/us/app/gak/id1541343166"

        },
        {
          id: 10,
          reportTitle: "2020 드림인 iOS 아카데미",
          appIcon: require("@/assets/images/appStoreImage/2020_dreamin/switching.png"),
          appTitle: "Switching",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EC%8A%A4%EC%9C%84%EC%B9%AD/id1542290155"
        },
        {
          id: 11,
          reportTitle: "2020 상반기 G-School",
          appIcon: require("@/assets/images/appStoreImage/etc/hanbok.png"),
          appTitle: "장인의 한복",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EC%9E%A5%EC%9D%B8%EC%9D%98%ED%95%9C%EB%B3%B5/id1534848276"

        },
        {
          id: 12,
          reportTitle: "2020 1학기 한양대학교 iOS App Design to Develop Course",
          appIcon: require("@/assets/images/appStoreImage/etc/GoongGemHY.png"),
          appTitle: "궁금하냥",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EA%B6%81%EA%B8%88%ED%95%98%EB%83%A5/id1528462830"
        },
        {
          id: 13,
          reportTitle: "2020 1학기 한양대학교 iOS App Design to Develop Course",
          appIcon: require("@/assets/images/appStoreImage/etc/AlertMap.png"),
          appTitle: "알람맵",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EC%95%8C%EB%9E%8C%EB%A7%B5/id1521612027"
        },
        {
          id: 14,
          reportTitle: "2020 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
          appIcon: require("@/assets/images/appStoreImage/etc/YourFit.png"),
          appTitle: "YourFit",
          appStoreAddress:
            "https://apps.apple.com/us/app/yourfit/id1498397067"
        },
        {
          id: 15,
          reportTitle: "2020 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
          appIcon: require("@/assets/images/appStoreImage/etc/SleepWithAI.png"),
          appTitle: "SleepWithAI",
          appStoreAddress:
            "https://apps.apple.com/us/app/sleepwithai/id1498395373"
        },
        {
          id: 16,
          reportTitle: "2019 여름방학 광운대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/etc/travel.png"),
          appTitle: "여~행님",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EC%97%AC-%ED%96%89%EB%8B%98/id1482280828"
        },
        {
          id: 17,
          reportTitle: "2019 1학기 한양대학교 공과대학 컴퓨터/SW 전공",
          appIcon: require("@/assets/images/appStoreImage/etc/AboutHanyang.png"),
          appTitle: "AboutHanyang",
          appStoreAddress:
            "https://apps.apple.com/us/app/about-hanyang/id1469853999"
        },
        {
          id: 18,
          reportTitle: "2019 1학기 한양대학교 공과대학 컴퓨터/SW 전공",
          appIcon: require("@/assets/images/appStoreImage/2019_hyu_spring/01/appIcon.png"),
          appTitle: "Hanyang Smart Order",
          appStoreAddress:
            "https://apps.apple.com/kr/app/한양-스마트오더/id1470195139",
          cardNewsAddress:
            "https://www.facebook.com/codershighteam/posts/1228818117320856?__tn__=-R"
        },
        {
          id: 19,
          reportTitle: "2019 겨울방학 중앙대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2019_cau_winter/01/appIcon.png"),
          appTitle: "SketchWord",
          appStoreAddress:
            "https://itunes.apple.com/kr/app/sketchword/id1453309917?mt=8"
        },
        {
          id: 20,
          reportTitle: "2019 겨울방학 중앙대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2019_cau_winter/03/appIcon.png"),
          appTitle: "미니약국",
          appStoreAddress:
            "https://apps.apple.com/kr/app/미니약국/id1469902368",
          cardNewsAddress:
            "https://www.facebook.com/codershighteam/posts/1237510246451643"
        },
        {
          id: 21,
          reportTitle: "2019 겨울방학 중앙대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2019_cau_winter/02/appIcon.png"),
          appTitle: "전국 ATM",
          appStoreAddress:
            "https://itunes.apple.com/kr/app/전국-atm-찾기/id1454131770?mt=8"
        },

        {
          id: 22,
          reportTitle: "2019 겨울방학 중앙대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/etc/ReverseRecipeat.png"),
          appTitle: "거꾸로레시피",
          appStoreAddress:
            "https://apps.apple.com/kr/app/%EA%B1%B0%EA%BE%B8%EB%A1%9C-%EB%A0%88%EC%8B%9C%ED%94%BC/id1452760217"
        },
        {
          id: 23,
          reportTitle: "2019 겨울방학 동국대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/etc/MoviePlanet.png"),
          appTitle: "MoviePlanet",
          appStoreAddress:
            "https://apps.apple.com/us/app/movieplanet/id1452124136"
        },
        {
          id: 24,
          reportTitle: "2019 겨울방학 동국대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/etc/KodongPodong.png"),
          appTitle: "코동포동",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EC%BD%94%EB%8F%99%ED%8F%AC%EB%8F%99/id1453124118"
        },
        {
          id: 25,
          reportTitle: "2019 겨울방학 동국대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/etc/DonggukGraduation.png"),
          appTitle: "동국아 졸업하자",
          appStoreAddress:
            "https://apps.apple.com/us/app/%EB%8F%99%EA%B5%AD%EC%95%84%EC%A1%B8%EC%97%85%ED%95%98%EC%9E%90/id1452125551"

        },
        {
          id: 26,
          reportTitle: "2018 여름방학 서울여대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2018_swu_summer/01/appIcon.png"),
          appTitle: "세이브 돈돈",
          appStoreAddress: "https://itunes.apple.com/kr/app/id1423018646"
        },
        {
          id: 27,
          reportTitle: "2018 여름방학 서울여대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2018_swu_summer/02/appIcon.png"),
          appTitle: "재고재고",
          appStoreAddress:
            "https://itunes.apple.com/kr/app/%EC%9E%AC%EA%B3%A0%EC%9E%AC%EA%B3%A0/id1423132116?mt=8"
        },
        {
          id: 28,
          reportTitle: "2018 여름방학 중앙대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2018_cau_summer/01/appIcon.png"),
          appTitle: "술케줄",
          appStoreAddress:
            "https://itunes.apple.com/kr/app/%EC%88%A0%EC%BC%80%EC%A5%B4/id1433295127?mt=8"
        },
        {
          id: 29,
          reportTitle: "2018 1학기 한양대학교 공과대학 컴퓨터/SW 전공",
          appIcon: require("@/assets/images/appStoreImage/2018_hyu_spring/01/appIcon.png"),
          appTitle: "스마트한양",
          appStoreAddress:
            "https://itunes.apple.com/us/app/smarthanyang/id1420489675?ls=1&mt=8"
        },
        {
          id: 30,
          reportTitle: "2018 1학기 한양대학교 공과대학 컴퓨터/SW 전공",
          appIcon: require("@/assets/images/appStoreImage/etc/WishListHY.png"),
          appTitle: "WishListHY",
          appStoreAddress:
            "https://apps.apple.com/us/app/wishlisthy/id1420501007"
        },
        {
          id: 31,
          reportTitle: "2018 1학기 한양대학교 공과대학 컴퓨터/SW 전공",
          appIcon: require("@/assets/images/appStoreImage/etc/CleanManager.png"),
          appTitle: "CleanManager",
          appStoreAddress:
            "https://apps.apple.com/us/app/cleanmanager/id1404185575"
        },
        {
          id: 32,
          reportTitle: "2018 겨울방학 중앙대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2018_cau_winter/01/appIcon.png"),
          appTitle: "모으다",
          appStoreAddress:
            "https://itunes.apple.com/kr/app/1%EC%9B%94-1%EC%9D%BC-%EB%AA%A9%ED%91%9C-%EA%B4%80%EB%A6%AC-%EC%96%B4%ED%94%8C%EB%A6%AC%EC%BC%80%EC%9D%B4%EC%85%98/id1218696438?mt=8"
        },
        {
          id: 33,
          reportTitle: "2018 겨울방학 동국대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2018_dgu_winter/01/appIcon.png"),
          appTitle: "PillingTime",
          appStoreAddress:
            "https://itunes.apple.com/us/app/%ED%95%84%EB%A7%81%ED%83%80%EC%9E%84/id1350330770?mt=8"
        },
        {
          id: 34,
          reportTitle: "2018 겨울방학 동국대학교 iOS 특강",
          appIcon: require("@/assets/images/appStoreImage/2018_dgu_winter/02/appIcon.png"),
          appTitle: "도리니티",
          appStoreAddress:
            "https://itunes.apple.com/us/app/%EB%8F%84%EB%A6%AC%EB%8B%88%ED%8B%B0/id1350340428?mt=8"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
